import { Injectable } from '@angular/core';
import { RequestsProvider } from '../requests/requests';
import { ActiviteInterne, CrActiviteInterne } from '../../models/activite-interne/activite-interne.model';
import { environment } from '../../../../environments/environment';
import { LoggerFactory } from '../logger/logger-factory.service';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { UuidResponse } from '../../models/common.model';
import { Problem } from '../../models/problem.model';
import { getProblemFromHttpError } from '../../utils/httpUtils';

@Injectable({ providedIn: 'root' })
export class ActiviteInterneProvider {
  private urlCrActiviteInterne: string = environment.apis.API_DACTECH_BACK_ROOT + '/v1/crActiviteInternes';
  private urlActiviteInterne: string = environment.apis.API_DACTECH_BACK_ROOT + '/v1/activitesInternes';
  private logger: LoggerWrapper;

  constructor(
    private requestsProvider: RequestsProvider,
    private loggerFactory: LoggerFactory
  ) {
    this.logger = this.loggerFactory.getInstance(this);
  }

  async postActiviteInterne(activite: ActiviteInterne): Promise<UuidResponse> {
    try {
      return await this.requestsProvider.post(this.urlActiviteInterne, activite);
    } catch (httpError) {
      let problem: Problem = getProblemFromHttpError(httpError);
      this.logger.error(httpError, 'Erreur postActiviteInterne', problem.detail);
      return null;
    }
  }

  async postCrActiviteInterne(cr: CrActiviteInterne): Promise<UuidResponse> {
    return await this.requestsProvider.post(this.urlCrActiviteInterne, cr);
  }

  async getCr(idIntervenant: string, saisi_apres_date: string, saisi_avant_date: string): Promise<CrActiviteInterne[]> {
    let url =
      this.urlCrActiviteInterne +
      `?id_intervenant=${idIntervenant}&saisi_apres_date=${saisi_apres_date}&saisi_avant_date=${saisi_avant_date}`;
    return await this.requestsProvider.get(url);
  }
}
